module.exports = __webpack_public_path__ + "static/kran02_1920-621f4d61318c9ceafa55b8b2417ca3ff.jpg";